import { Component, signal, DestroyRef, inject } from '@angular/core';
import { Commands } from '../../services/commands/commands';
import { Events } from '../../services/events/events';
import { Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RoomSetup } from "../../../../components/room-setup/room-setup";

@Component({
  selector: 'app-waiting-room',
  imports: [RouterLink, RoomSetup],
  templateUrl: './waiting-room.html',
  styleUrl: './waiting-room.css'
})
export class WaitingRoom {

  // PROPERTIES

  private destroyRef = inject(DestroyRef);
  private is_current_player_leader?: boolean;

  // SIGNALS

  protected room_id = signal<string>("");
  protected is_current_player_selected = signal<boolean>(false);
  protected is_leader_selected = signal<boolean>(false);
  protected is_prompter_selected = signal<boolean>(false);

  // ROOM ID LISTENER

  public setRoomId(room_id: string){
    this.room_id.set(room_id);
  }

  // EVENT LISTENERS

  private gameStartListener(): void{

    this.events.onGameStart()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: data => {

          this.is_current_player_leader
          // add room id as parameter to have info always available on page reload, nothing else
          ? this.router.navigate([`/mind-link/leader-board/${this.room_id()}`])
          : this.router.navigate([`/mind-link/prompter-board/${this.room_id()}`])

        }
      });

  }

  private playerSelectedListener(): void{

    this.events.onPlayerSelected()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: data => {

          if (data.player === 'leader')
            this.is_leader_selected.set(true);

          else if (data.player === 'prompter')
            this.is_prompter_selected.set(true);

        }
      });

  }

  private playerLeftListener(): void{

    this.events.onPlayerLeft()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: data => {

          // if in the room there is an active game, a single player can't disconnect, only both
          // if the game is not yet started, only one player was selected
          // in any case, we can simply enable again both roles
          this.is_leader_selected.set(false);
          this.is_prompter_selected.set(false);

        }
      });

  }

  public initializeListeners(): void{

    this.gameStartListener();
    this.playerSelectedListener();
    this.playerLeftListener();

  }

  // COMMANDS

  public selectPlayer(is_leader: boolean): void{

    this.is_current_player_leader = is_leader;

    this.commands.selectPlayer(is_leader, () => {

      this.is_current_player_selected.set(true);

    });

  }

  // LIFECYCLE

  constructor(
    private router: Router,
    private commands: Commands,
    private events: Events
  ){}

}
